// Import necessary modules and types
import { IPaginatedResponse } from 'common/types/api.types'
import console from 'console'
import { GetServerSidePropsContext } from 'next'
import { ApiPathsWiki } from 'services/community/wiki.api'
import { httpServer } from 'services/http'

const URL = 'https://seaplify.com'

// Function to generate the sitemap XML
function generateSiteMap(wikiSlugs: string[]) {
  return `<?xml version="1.0" encoding="UTF-8"?>
  <urlset xmlns="https://www.sitemaps.org/schemas/sitemap/0.9">
    ${wikiSlugs
      .map((slug) => {
        return `
        <url>
          <loc>${`${URL}/community/wiki/${slug}`}</loc>
        </url>
        `
      })
      .join('')}
  </urlset>
  `
}

// Function to fetch all paginated data
async function fetchAllWikis() {
  try {
    let page = 1
    const limit = 1000
    let allWikis: string[] = []
    let hasNextPage = true

    while (hasNextPage) {
      const { data: paginatedWikis } = await httpServer.get<IPaginatedResponse<string[][]>>(
        `${process.env.NEXT_PUBLIC_SALIAJOB_API_BASE_URL}${ApiPathsWiki.publicWikiIds(page, limit)}`,
      )

      allWikis = allWikis.concat(paginatedWikis.data.flatMap((data) => data))
      hasNextPage = page < paginatedWikis.meta.totalPages
      page++
    }
    return allWikis
  } catch (error) {
    console.log('error', error)
    return []
  }
}

// getServerSideProps function to generate and serve the sitemap
export async function getServerSideProps({ res }: GetServerSidePropsContext) {
  // Fetch all wiki slugs
  const wikiSlugs = await fetchAllWikis()

  // Generate the XML sitemap with the wiki slugs
  const sitemap = generateSiteMap(wikiSlugs)

  // Set the response headers and send the sitemap XML
  res.setHeader('Content-Type', 'text/xml')
  res.write(sitemap)
  res.end()

  return {
    props: {},
  }
}

// Default export for the sitemap page
export default function SiteMap() {}
